import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../_services/authentication.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) {}

    intercept( request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add auth header with jwt if user is logged in and request is to the api url
        const rawToken = this.authenticationService.rawToken;
        const isLoggedIn = rawToken && rawToken.token;
        const isApiUrl = request.url.startsWith(environment.apiUrl) || request.url.startsWith(environment.websiteUrl);
        if (isLoggedIn && isApiUrl && this.authenticationService.isAuthenticated) {
            request = request.clone({
                setHeaders: { Authorization: `Bearer ${rawToken.token}` }
            });
        }

        return next.handle(request);
    }
}
